import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import AccumulationTableFuturesExternal from '../../pages/markets/component/accumulation-table-futures-external';
import DetailPageHeader from '../../pages/markets/component/detail-page-header';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import FuturesExternalSearch from '../../pages/markets/component/futures-external-search';
import '../../pages/markets/pages/futures-external-short-covering/futures-external-short-covering.m.css';

const FuturesExternalShortCovering = () => {
  const queryClient = new QueryClient();
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        {initialLoading ? (
          <div styleName="initial-loading-container"></div>
        ) : (
          <div styleName="detail-header-container">
            <div className="container">
              <DetailPageHeader widget={true} />
            </div>
          </div>
        )}

        <div styleName="overall-container">
          <div styleName="search-widget-container" className="container">
            <FuturesExternalSearch />

            <AccumulationTableFuturesExternal limit={200} external={true} widget={true} />
          </div>
        </div>
        <div className="container">
          <FuturesAndOptionsFaq widget={true} />
        </div>
      </>
    </QueryClientProvider>
  );
};

export default FuturesExternalShortCovering;
